var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.402 0.0920172L11.502 2.85052C11.6517 2.92286 11.7776 3.03417 11.8656 3.17194C11.9536 3.30971 12.0001 3.46849 12 3.63045V4.46671C12 4.86742 11.664 5.19263 11.25 5.19263H10.8V9.83853H11.4C11.5591 9.83853 11.7117 9.89971 11.8243 10.0086C11.9368 10.1175 12 10.2652 12 10.4193C12 10.5733 11.9368 10.721 11.8243 10.8299C11.7117 10.9388 11.5591 11 11.4 11H0.6C0.44087 11 0.288258 10.9388 0.175736 10.8299C0.0632141 10.721 0 10.5733 0 10.4193C0 10.2652 0.0632141 10.1175 0.175736 10.0086C0.288258 9.89971 0.44087 9.83853 0.6 9.83853H1.2V5.19263H0.75C0.336 5.19263 0 4.86742 0 4.46671V3.63045C0 3.3273 0.162 3.04855 0.4236 2.89059L5.5974 0.0920172C5.7224 0.0315045 5.86024 0 6 0C6.13976 0 6.277 0.0315045 6.402 0.0920172ZM9 5.19263H3V9.83853H4.2V6.3541H5.4V9.83853H6.6V6.3541H7.8V9.83853H9V5.19263ZM6 2.28895C5.84087 2.28895 5.68826 2.35013 5.57574 2.45904C5.46321 2.56795 5.4 2.71566 5.4 2.86968C5.4 3.0237 5.46321 3.17142 5.57574 3.28033C5.68826 3.38923 5.84087 3.45042 6 3.45042C6.15913 3.45042 6.31174 3.38923 6.42426 3.28033C6.53679 3.17142 6.6 3.0237 6.6 2.86968C6.6 2.71566 6.53679 2.56795 6.42426 2.45904C6.31174 2.35013 6.15913 2.28895 6 2.28895Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.f01ac53f9a545151eadc9af1083ba434.svg";
export { ForwardRef as ReactComponent };